import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

interface SuccessMessageProps {
  message: string;
  redirectPath?: string;
  onRedirect?: () => void;
  autoRedirectSeconds?: number;
  actionLabel?: string;
  onAction?: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message,
  redirectPath,
  onRedirect,
  autoRedirectSeconds = 3,
  actionLabel,
  onAction,
}) => {
  const [countdown, setCountdown] = React.useState(autoRedirectSeconds);

  useEffect(() => {
    if (countdown > 0 && onRedirect) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0 && onRedirect) {
      onRedirect();
    }
  }, [countdown, onRedirect]);

  return (
    <div className="text-center py-8">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success/10 mb-4 animate-scale-in">
        <Icon name="CheckCircle2" size={32} className="text-success" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">Succes!</h3>
      <p className="text-sm text-muted-foreground mb-6 whitespace-pre-wrap break-words">{message}</p>
      {actionLabel && onAction && (
        <div className="mb-6">
          <Button variant="outline" size="lg" onClick={onAction} iconName="ExternalLink" iconPosition="right">
            {actionLabel}
          </Button>
        </div>
      )}
      {onRedirect && (
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Redirecționare în {countdown} secund{countdown === 1 ? 'ă' : 'e'}...
          </p>
          <Button
            variant="default"
            size="lg"
            type="button"
            onClick={onRedirect}
            iconName="ArrowRight"
            iconPosition="right"
          >
            Continuă
          </Button>
        </div>
      )}
    </div>
  );
};

export default SuccessMessage;
